
export default {
  name: "the-about-step",
  props: {
    title: {
      required: true,
      default: "",
    },
    description: {
      required: true,
      default: "",
    },
    layout: {
      required: false,
      type: String,
      default: "chain",
    },
    tempUser: {
      required: false,
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      validated: false,
      rules: {
        required: (value) => !!value || "Dette feltet er obligatorisk.",
        name: (value) => {
          const pattern = /^[a-zA-Z\Wæøå]{2,}$/;
          return (
            pattern.test(value.trim()) ||
            "Navn kan ikke inneholde tall eller spesialtegn."
          );
        },
      },
    };
  },
  mounted() {
    this.firstName = this.tempUser.firstName;
    this.lastName = this.tempUser.lastName;
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.nameInput.$refs.input.focus();
      });
    });
  },
};
